<template>
  <el-dialog
    :visible.sync="show"
    custom-class="designerInfo"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="dialog-box">
      <img class="closebtn" src="@/assets/serve/designer/close.png" @click="closeDialog">
      <div class="title">{{ info.case_name }}</div>
      <div class="info">
        <div class="right">
          <div class="top">
            <div class="location">
              位置 | {{ info.province }} {{ info.city }}
            </div>
            <div class="product">
              产品 |
              {{
                info.products
                  ? JSON.parse(info.products)[0].product
                  : ""
              }}
            </div>
          </div>
          <div class="bottom">
            <div class="square">
              面积 | {{ info.area ? `${info.area} 平方米` : "" }}
            </div>
            <div class="color">
              花色 |
              {{
                info.products
                  ? JSON.parse(info.products)[0].model
                  : ""
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="text">{{ info.comment }}</div>
      <div class="before">焕新前</div>
      <template v-if="info.before_photos">
        <img
          v-for="(item, index) in JSON.parse(info.before_photos)"
          :key="'before_photos' + index"
          :src="item.pic_url"
          alt=""
          width="100%"
        />
      </template>
      <div class="after">焕新后</div>
      <template v-if="info.after_photos">
        <img
          v-for="(item, index) in JSON.parse(info.after_photos)"
          :key="'after_photos' + index"
          :src="item.pic_url"
          alt=""
          width="100%"
        />
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { formatDate } from "@/util/utils";
export default {
  name: 'renewInfo',
  components:{ 
  },
  props: {
    show: {},
    info:{}
  },
  data() {
    return {
        
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
    // 格式化时间
    formatDate(date, fmt) {
      return formatDate(date, fmt);
    },
    closeDialog() {
      this.$emit('close', false)
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog.designerInfo {
  width: 1180px;
  position: absolute;
  top: 34px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 75px 120px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    .dialog-box {
      position: relative;
      .title {
        font-size: 48px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #009538;
        margin-bottom: 45px;
        text-align: left;
      }
      .info {
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 44px;
        .left {
          display: flex;
          flex: 1;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .headPic {
            width: 80px;
            height: 80px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 50%;
            text-align: center;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 100%;
              height: 100%;
              vertical-align: top;
              object-fit: cover;
              transition: all 0.3s linear;
              &:hover {
                transform: scale(1.2);
              }
            }
          }
          .name-box {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            margin-left: 18px;
            text-align: left;
            .name {
              font-size: 24px;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              color: #595858;
            }
            .date {
              font-size: 18px;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              color: #9e9e9f;
            }
          }
        }
        .right {
          width: 645px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: space-between;
          background: #eeefef;
          border-radius: 10px;
          padding: 24px 29px;
          .top,
          .bottom {
            display: flex;
            flex-direction: row;
            flex: 1;
            div {
              display: flex;
              flex-direction: row;
              flex: 1;
              justify-content: flex-start;
              font-size: 18px;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              color: #595858;
            }
          }
          .top {
            margin-bottom: 5px;
          }
        }
      }
      .text {
        font-size: 24px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #595858;
        line-height: 44px;
        text-align: left;
        margin-bottom: 75px;
      }
      .before, .after {
        font-weight: 400;
        font-size: 30px;
        color: #4D4D4D;
        text-align: left;
        margin: 20px 0;
        font-family: FZLanTingHeiS-DB-GB;
      }
      .closebtn {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -75px;
        right: -220px;
        cursor: pointer;
      }
      .leftbtn {
        width: 58px;
        height: 58px;
        position: absolute;
        top: 430.5px;
        left: -250.5px;
        cursor: pointer;
      }
      .rightbtn {
        width: 58px;
        height: 58px;
        position: absolute;
        top: 430.5px;
        right: -250.5px;
        cursor: pointer;
      }
    }
  }
}
</style>